import React from 'react';
import HoverMenu from 'ats/components/hover-menu/HoverMenu';
import { skillStore } from './SkillStore';
import { SkillEdit } from './SkillEdit';
import { SkillCreate } from './SkillCreate';
import { ListStore } from '../../../shared/stores/ListStore';
import { observer } from 'mobx-react';
import SettingsTableSkeleton from '../SettingsTableSkeleton';
import {
	rolesAllowed,
	USER_ROLES
} from '../../../shared/security/RolesAllowed';
import SettingsSubsectionHeader from '../SettingsSubsectionHeader';
import SettingsListToolbar from '../SettingsListToolbar';
import SettingsListEmptyState from '../SettingsListEmptyState';
import { getSettingsSectionLabel } from '../settingsSections';

@rolesAllowed([USER_ROLES.ADMIN, USER_ROLES.MANAGER])
@observer
export class Skills extends React.Component {
	state = {
		data: [],
		filterText: '',
		loading: true
	};

	constructor(props) {
		super(props);
		this.listStore = new ListStore(skillStore, {
			entityName: 'Technology',
			createModal: (
				<SkillCreate
					handleSuccess={() => {
						this.search();
						this.setState({ filterText: '' });
					}}
				/>
			),
			editModal: item => (
				<SkillEdit
					skill={item}
					handleSuccess={() => {
						this.search();
						this.setState({ filterText: '' });
					}}
				/>
			)
		});
	}

	componentDidMount() {
		this.search();
	}

	search(value) {
		value = value ? value : '';
		this.setState({ loading: true });
		skillStore.getSkills(value).then(result => {
			if (result.status === 'success' && result.data) {
				this.setState({ data: result.data, loading: false });
			}
		});
	}

	hasFilters = () => Boolean(this.state.filterText.trim());

	clearFilters = () => {
		this.setState({ filterText: '' }, () => {
			this.search();
		});
	};

	getMenuItems(row) {
		return [
			{
				label: 'Edit',
				img: '/ats/icons/edit-icon.svg',
				onClick: () => this.listStore.handleEdit(row)
			},
			{
				label: 'Delete',
				img: '/ats/icons/trash-icon.svg',
				className: 'is-danger',
				onClick: () =>
					this.listStore.handleDelete(row, this.onDeleteSuccess, true)
			}
		];
	}

	render() {
		const { data, loading, filterText } = this.state;
		const isEmpty = !loading && data.length === 0;

		return (
			<div className="Skills container">
				<SettingsSubsectionHeader
					title={getSettingsSectionLabel('technologies')}
					actions={
						<SettingsListToolbar
							searchValue={filterText}
							onSearchChange={value => {
								this.search(value);
								this.setState({ filterText: value });
							}}
							createLabel={`Create ${this.listStore.modalsConfigs.entityName}`}
							onCreate={() => this.listStore.handleCreate()}
						/>
					}
				/>
				<div className="columns">
					<div className="column is-12 table-wrapper">
						<table className="table is-fullwidth">
							<thead>
								<tr>
									<th>Name</th>
									<th className="actions-column" />
								</tr>
							</thead>
							{loading ? (
								<SettingsTableSkeleton columns={2} />
							) : !isEmpty ? (
								<tbody>
									{data.map(row => {
										return (
											<tr key={row.id}>
												<td className="has-text-weight-bold">{row.name}</td>
												<td className="actions-column">
													<HoverMenu
														id={row.id}
														position="left"
														buttonIcon={
															<img
																src="/ats/icons/three-dots-icon.svg"
																alt="More actions"
															/>
														}
														items={this.getMenuItems(row)}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							) : null}
						</table>
						{!loading && isEmpty ? (
							<SettingsListEmptyState
								entityPlural="technologies"
								hasFilters={this.hasFilters()}
								onClearFilters={this.clearFilters}
							/>
						) : null}
					</div>
				</div>
			</div>
		);
	}

	onDeleteSuccess = item => {
		this.search();
		this.setState({ filterText: '' });
	};
}
